const FILE_DATA_FIELD = 'data'

function formDataForFile(file) {
  const formData = new FormData()
  formData.append(FILE_DATA_FIELD, file, file.name)
  return formData
}

export function createFormData(file, fields) {
  return Object.entries(fields).reduce((acc, [fieldName, fieldValue]) => {
    if (fieldName === FILE_DATA_FIELD) {
      throw new Error(`Invalid form data field '${fieldName}'`)
    }
    acc.append(fieldName, JSON.stringify(fieldValue))
    return acc
  }, formDataForFile(file))
}
